import React, { Component } from "react";
import { message, Typography, List, Tag, Card, Row, Col, Divider } from "antd";
import { connect } from "react-redux";
import axios from "axios";
import { withRouter } from "react-router-dom"; 
import { ModalItem, ButtonItem } from "../../../../Components/Items";
import { ShoppingCartOutlined, ProjectOutlined, RocketOutlined  } from "@ant-design/icons";

const { Text, Title } = Typography;

class ModalGenerarOCDropshipping extends Component {
  state = {
    loading: false,
    venta: null,
    insumosDropshipping: [],
    proveedorDropshippingId : null,
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible && this.props.ventaId) {
      this.consultarVentaDetalle();
    }
  }

  consultarVentaDetalle = () => {
    this.setState({ loading: true });
    const { ventaId, empresaId, headersToken } = this.props;

    axios
      .post(
        "ventasEcommerce/obtenerVentaPorId",
        { ventaId, empresaId },
        { headers: headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          const venta = res.data.venta;
          
          const filtrados = venta.insumos.filter((ins) => !!ins.dropshipping);

          this.setState({
            venta,
            proveedorDropshippingId: res.data.proveedorDropshippingId,
            insumosDropshipping: filtrados,
            loading: false,
          });
        } else {
          this.setState({ loading: false });
          message.warning(res.data.message);
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Error al obtener el detalle de la venta");
      });
  };

  irAGenerarOC = () => {
    const { venta, insumosDropshipping , proveedorDropshippingId } = this.state;
    const datosPrecargados = {
    ventaSerie : venta.serieNumero, 
      vieneDeEcommerce: true,
      ventaId: venta._id,
      proyectoId: venta.proyectoId,
      proveedorId: proveedorDropshippingId,
      insumos: insumosDropshipping.map(ins => ({
        insumoId: ins.insumoId,
        cantidad: ins.cantidad,
        precioUnitario: ins.precioUnitario, 
        descripcion: ins.descripcion
      }))
    };

    this.props.history.push({
      pathname: "/panel/agregarOrdenDeCompra", 
      state: { datosPrecargados }
    });
  };

  generarGuia = () => {
    const { ventaId, origenKey, empresaId, headersToken, onSuccess } = this.props;

    this.setState({ loading: true });

    axios
      .post(
        "ventasEcommerce/generarGuiaEnvio",
        { ventaId, origenKey, empresaId },
        { headers: headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if ( res.data.success === 2) { 
          message.success("¡Guía generada exitosamente!");
          if (onSuccess) onSuccess(); 
        } else {
          message.error("¡Ocurrió un error generando la guía!");
        }
      })
      .catch((err) => {
        console.error("Error en Axios:", err);
        this.setState({ loading: false });
        message.error("Error de conexión al procesar la guía.");
      });
  };

  render() {
    const { visible, onCancel } = this.props;
    const { venta, insumosDropshipping, loading } = this.state;
    const todoListo = venta && venta.ordenDeCompra;
    return (
      <ModalItem
        title={
          <span>
            <ShoppingCartOutlined /> Solicitud de Dropshipping (URREA)
          </span>
        }
        visible={visible}
        onCancel={onCancel}
        width={750}
        spinning={loading}
      >
        

        {venta && (
          <>
            <Card size="small" style={{ marginBottom: 15, background: "#f0f5ff", border: "1px solid #adc6ff" }}>
              <Row>
                <Col span={24}>
                  <Title level={5} style={{ margin: 0, color: "#1d39c4" }}>
                    Datos del Proyecto / Venta
                  </Title>
                  <Text strong>Folio de Venta:</Text> <Tag color="blue">{venta.serieNumero}</Tag>
                  <Divider type="vertical" />
                  <Text strong>Proyecto Asignado:</Text> 
                  <Tag color="cyan">{venta.nombreProyecto || "Sin proyecto"}</Tag>
                </Col>
              </Row>
            </Card>

            <List
              header={<Text strong style={{ fontSize: "15px" }}>Insumos a solicitar al Proveedor</Text>}
              bordered
              dataSource={insumosDropshipping}
              style={{ background: "white", borderRadius: "8px" }}
              renderItem={(item) => (
                <List.Item>
                  <List.Item.Meta
                    title={<Text strong style={{ color: "#fa8c16" }}>{item.descripcion || item.leyenda}</Text>}
                    description={
                      <div style={{ fontSize: 12, marginTop: 4 }}>
                        <Text type="secondary">Clave: {item.clave || "N/A"}</Text>
                        <Divider type="vertical" />
                        <Tag color="orange" style={{ borderRadius: "10px" }}>
                          Cant a pedir: {item.cantidad}
                        </Tag>
                      </div>
                    }
                  />
                </List.Item>
              )}
            />
            
            <div style={{ marginTop: 15 }}>
              <Text type="secondary" style={{ fontSize: 12 }}>
                * Al hacer clic en "Ir a Generar Orden de Compra", serás redirigido al módulo de compras con estos insumos precargados. La guía de envío se habilitará cuando la OC esté ligada a esta venta.
              </Text>
            </div>
          </>
        )}
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginBottom: 15, marginTop: 15 }}>
          <ButtonItem  
            type="primary" 
            onClick={this.irAGenerarOC}
            icon={<ProjectOutlined />}
            disabled={insumosDropshipping.length === 0}
          >
            Ir a Generar Orden de Compra
          </ButtonItem> 
          <ButtonItem
            type="primary"
            onClick={this.generarGuia}
            disabled={!todoListo}
            verde
            icon={<RocketOutlined />}
          >
            Generar Guía
          </ButtonItem>

        </div>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default withRouter(connect(mapStateToProps)(ModalGenerarOCDropshipping));